import { useEffect, useRef } from 'react';

const MODIFIER_TOKENS = ['cmd', 'ctrl', 'alt', 'shift'];

export function useHotkey(combo: string | undefined, handler: () => void) {
    const handlerRef = useRef(handler);
    handlerRef.current = handler;

    useEffect(() => {
        if (!combo) return;

        const tokens = combo
            .toLowerCase()
            .split('+')
            .map((token) => token.trim())
            .filter(Boolean);
        const key = tokens.find((token) => !MODIFIER_TOKENS.includes(token));
        if (!key) return;

        const needsModifier = tokens.includes('cmd') || tokens.includes('ctrl');
        const needsShift = tokens.includes('shift');
        const needsAlt = tokens.includes('alt');

        const handleKeyDown = (event: KeyboardEvent) => {
            if (
                event.key.toLowerCase() !== key ||
                (event.metaKey || event.ctrlKey) !== needsModifier ||
                event.shiftKey !== needsShift ||
                event.altKey !== needsAlt
            ) {
                return;
            }
            event.preventDefault();
            handlerRef.current();
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [combo]);
}
